<!-- MODALE DI INFO -->
<div *ngIf="message.type==='info'">
  <div class="d-flex align-items-center" mat-dialog-title>
    <mat-icon class="me-2">info_outline</mat-icon>
    <h5 class="modal-title my-0">{{message.title}}</h5>
  </div>

  <mat-dialog-content>
    <p class="preserve-newline" [innerHTML]="message.content"></p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-dialog-close>{{ 'common.close' | translate }}</button>
  </mat-dialog-actions>
</div>

<!-- MODALE DI WARNING -->
<div *ngIf="message.type==='warning'">
  <div class="d-flex align-items-center" mat-dialog-title>
    <mat-icon class="me-2">warning_amber</mat-icon>
    <h5 class="modal-title my-0">{{message.title}}</h5>
  </div>

  <mat-dialog-content>
    <p class="preserve-newline" [innerHTML]="message.content"></p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-dialog-close>{{ 'common.close' | translate }}</button>
  </mat-dialog-actions>
</div>

<!-- MODALE DI CONFERMA -->
<div *ngIf="message.type==='confirm'">
  <div class="d-flex align-items-center" mat-dialog-title>
    <mat-icon class="me-2">info_outline</mat-icon>
    <h5 class="modal-title my-0">{{message.title}}</h5>
  </div>

  <mat-dialog-content>
    <p class="preserve-newline" [innerHTML]="message.content"></p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button [mat-dialog-close]="false">{{ 'common.cancel' | translate }}</button>

    <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ 'common.confirm' | translate }}</button>
  </mat-dialog-actions>
</div>

<!-- MODALE DI ERROR -->
<div *ngIf="message.type==='error'">
  <div class="d-flex align-items-center" mat-dialog-title>
    <mat-icon class="me-2">error_outline</mat-icon>
    <h5 class="modal-title my-0">{{message.title}}</h5>
  </div>

  <mat-dialog-content>
    <p class="preserve-newline" [innerHTML]="message.content"></p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-dialog-close>{{ 'common.close' | translate }}</button>
  </mat-dialog-actions>
</div>

<!-- MODALE DI SUCCESS -->
<div *ngIf="message.type==='success'" class="success-modal">
  <div class="d-flex align-items-center" mat-dialog-title>
    <mat-icon class="me-2">check_circle_outline</mat-icon>
    <h5 class="modal-title my-0">{{message.title}}</h5>
  </div>


  <mat-dialog-content>
    <p class="preserve-newline" [innerHTML]="message.content"></p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-dialog-close>{{ 'common.close' | translate }}</button>
  </mat-dialog-actions>
</div>

<!-- MODALE CUSTOM -->
<div *ngIf="message.type==='custom'" class="custom-modal">
  <div class="mat-dialog-header">
    <div class="ps-4 modal-title">{{ message.title }}</div>
    <button class="mb-2" mat-icon-button (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <ng-template #customComponent></ng-template>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <!-- <button mat-raised-button color="primary" (click)="confirm(customComponent)">Conferma</button> -->
    <button *ngIf="!data.customButton; else customButton" mat-stroked-button color="primary" mat-dialog-close>{{
      'common.close' | translate }}</button>
    <ng-template #customButton></ng-template>
  </mat-dialog-actions>
</div>
